<template>
    <div :style="style" :class="classes">
        <Icon name="spinner" :size="size" :align="align" :pulse="pulse" :spin="spin" />
    </div>
</template>

<script>
    import Icon from './Icon.vue'

    export default {
        name  : 'Loader',
        components : {
            Icon,
        },
        props : {
            align : {
                type     : String,
                required : false,
                default  : 'center',
            },
            size : {
                type     : String,
                required : false,
                default  : '2x',
            },
            animation : {
                type     : String,
                required : false,
                validator(value) {
                    return ['spin', 'pulse'].indexOf(value) !== -1
                },
                default : `pulse`,
            },
            noPadding : {
                type : Boolean,
                required : false,
                default : false,
            },
            inline : {
                type : Boolean,
                required : false,
                default : false,
            },
        },

        computed : {
            spin() {
                return this.animation === `spin`
            },
            pulse() {
                return this.animation === `pulse`
            },
            classes() {
                return {
                    'p-3' : !this.noPadding,
                    'd-print-none' : true,
                }
            },
            style() {
                const style = {
                    display   : `inline`,
                    textAlign : `inherit`,
                }

                if (this.align) {
                    style.textAlign = this.align
                    style.display   = this.inline ? `inline` : `block`
                }

                return style
            },
        },
    }
</script>
